export enum RevenueGrowthRate {
    zeroToFive = 1, // 1-5%
    fiveToTen, // 5-10%
    tenToFifteen, // 10-15%
    fifteenToTwenty, // 15-20%
    twentyToTwentyFive, // 20-25%
    twentyFiveToThirty, // 25-30%
    thirtyToForty, // 30-40%
    fortyToFifty, // 40-50%
    fiftyOrMore, // 50%+
    noGrowth, // No Growth
    decliningRevenue, // Declining Revenue
}

export const RevenueGrowthRates = [
    {
        id: RevenueGrowthRate.decliningRevenue,
        name: 'Declining Revenue',
    },
    {
        id: RevenueGrowthRate.noGrowth,
        name: 'No Growth',
    },
    {
        id: RevenueGrowthRate.zeroToFive,
        name: '1-5%',
    },
    {
        id: RevenueGrowthRate.fiveToTen,
        name: '5-10%',
    },
    {
        id: RevenueGrowthRate.tenToFifteen,
        name: '10-15%',
    },
    {
        id: RevenueGrowthRate.fifteenToTwenty,
        name: '15-20%',
    },
    {
        id: RevenueGrowthRate.twentyToTwentyFive,
        name: '20-25%',
    },
    {
        id: RevenueGrowthRate.twentyFiveToThirty,
        name: '25-30%',
    },
    {
        id: RevenueGrowthRate.thirtyToForty,
        name: '30-40%',
    },
    {
        id: RevenueGrowthRate.fortyToFifty,
        name: '40-50%',
    },
    {
        id: RevenueGrowthRate.fiftyOrMore,
        name: '50%+',
    },
];

export const RevenueGrowthRateOptions = {
    [RevenueGrowthRate.decliningRevenue]: 'Declining Revenue',
    [RevenueGrowthRate.noGrowth]: 'No Growth',
    [RevenueGrowthRate.zeroToFive]: '1-5%',
    [RevenueGrowthRate.fiveToTen]: '5-10%',
    [RevenueGrowthRate.tenToFifteen]: '10-15%',
    [RevenueGrowthRate.fifteenToTwenty]: '15-20%',
    [RevenueGrowthRate.twentyToTwentyFive]: '20-25%',
    [RevenueGrowthRate.twentyFiveToThirty]: '25-30%',
    [RevenueGrowthRate.thirtyToForty]: '30-40%',
    [RevenueGrowthRate.fortyToFifty]: '40-50%',
    [RevenueGrowthRate.fiftyOrMore]: '50%+',
};
